import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@chhjit/react-components";

export const BedroomStudioIcon = ({
  className,
  fontSize = 24,
}: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    style={{ fill: "none", fontSize: fontSize }}
    fill="currentColor"
  >
    <rect
      x="4.86957"
      y="4.86956"
      width="41.1304"
      height="41.1304"
      fill="#F0CBA7"
    />
    <rect
      x="2.5"
      y="2.5"
      width="20.0435"
      height="20.0435"
      fill="#EA7200"
      stroke="#EA7200"
    />
    <rect
      x="22.5869"
      y="2.5"
      width="21"
      height="20.0435"
      fill="#EA7200"
      stroke="#EA7200"
    />
    <rect
      x="2.5"
      y="22.587"
      width="20.0435"
      height="21"
      fill="#EA7200"
      stroke="#EA7200"
    />
    <rect
      x="22.5869"
      y="22.587"
      width="21"
      height="21"
      fill="#EA7200"
      stroke="#EA7200"
    />
  </SvgIcon>
);
